import { render } from "./StockTableXQ.vue?vue&type=template&id=ede9608c&scoped=true"
import script from "./StockTableXQ.vue?vue&type=script&lang=js"
export * from "./StockTableXQ.vue?vue&type=script&lang=js"

import "./StockTableXQ.vue?vue&type=style&index=0&id=ede9608c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede9608c"]])

export default __exports__